import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "primo_cart";

const keyOf = (productId, selections) =>
  selections?.length
    ? `${productId}|${selections.map((s) => `${s.group}:${s.option}x${s.qty}`).join(",")}`
    : productId;

export const extrasOf = (selections = []) =>
  selections.reduce((s, o) => s + (o.price || 0) * o.qty, 0);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem(KEY) || "{}"));

  useEffect(() => localStorage.setItem(KEY, JSON.stringify(items)), [items]);

  const setQty = (product, qty, selections = []) =>
    setItems((prev) => {
      const next = { ...prev };
      const key = keyOf(product.id, selections);
      const q = Math.min(qty, product.stock);
      if (q <= 0) delete next[key];
      else next[key] = { product, qty: q, selections };
      return next;
    });

  const setQtyByKey = (key, qty) =>
    setItems((prev) => {
      const entry = prev[key];
      if (!entry) return prev;
      const next = { ...prev };
      const q = Math.min(qty, entry.product.stock);
      if (q <= 0) delete next[key];
      else next[key] = { ...entry, qty: q };
      return next;
    });

  const list = Object.entries(items).map(([key, v]) => {
    const selections = v.selections || [];
    return { key, ...v, selections, unitPrice: v.product.price + extrasOf(selections) };
  });
  const count = list.reduce((s, i) => s + i.qty, 0);
  const subtotal = list.reduce((s, i) => s + i.qty * i.unitPrice, 0);
  const qtyOf = (id) => items[id]?.qty || 0;
  const clear = () => setItems({});

  return (
    <CartContext.Provider value={{ list, count, subtotal, setQty, setQtyByKey, qtyOf, clear }}>{children}</CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
